var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-card" }, [
    _c("div", { staticClass: "modal-card-body has-text-centered" }, [
      _c("img", {
        staticClass: "image is-centered my-4",
        attrs: { src: "/statics/signar-logo.svg", width: "100", alt: "" },
      }),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-4" }, [_vm._v("Abriendo firmador")]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm.type === "current"
          ? _c("p", [
              _vm._v("¿No cuenta con Signar® Firmador?"),
              _c("br"),
              _vm._m(2),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "buttons is-centered" }, [
        _c(
          "a",
          {
            staticClass: "button is-dark",
            on: {
              click: function ($event) {
                return _vm.$parent.close()
              },
            },
          },
          [_vm._v("\n        Cerrar\n      ")]
        ),
        _vm._v(" "),
        _c(
          "a",
          { staticClass: "button is-primary", on: { click: _vm.reload } },
          [
            _c("i", { staticClass: "fas fa-redo" }),
            _vm._v(" Recargar listado\n      "),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("Si el firmador\n      "),
      _c("u", [_vm._v("NO")]),
      _vm._v(
        " se ejecutó, verifique si su navegador está bloqueando los pop-ups, deshabilitelos y vuelva a intentarlo\n    "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Recomendamos habilitar los pop-ups en Signar®")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { attrs: { href: "https://firmador.lyris.com.ar", target: "_blank" } },
      [_c("i", { staticClass: "fas fa-download" }), _vm._v(" Descárguelo aquí")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }